import { useState } from 'react'

function EyeIcon({ open }) {
  return open ? (
    <svg viewBox="0 0 16 16" className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z"/><circle cx="8" cy="8" r="2"/>
    </svg>
  ) : (
    <svg viewBox="0 0 16 16" className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13.5 13.5 2.5 2.5"/><path d="M6.5 6.6A2 2 0 0 0 9.4 9.5"/><path d="M4.2 4.3C2.8 5.2 1.7 6.5 1 8c1.3 2.8 4.2 5 7 5 1.2 0 2.4-.4 3.4-1"/><path d="M10.6 10.7C12.2 9.8 13.4 8.5 15 8c-1.3-2.8-4.2-5-7-5-.7 0-1.4.1-2 .4"/>
    </svg>
  )
}

export default function FormField({ label, type = 'text', value, onChange, placeholder, autoComplete, maxLength }) {
  const [show, setShow] = useState(false)
  const isPassword = type === 'password'
  const inputType  = isPassword ? (show ? 'text' : 'password') : type

  return (
    <div className="space-y-1.5">
      <label className="block text-xs font-medium" style={{ color: 'var(--text-2)' }}>{label}</label>
      <div className="relative">
        <input
          type={inputType}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          autoComplete={autoComplete}
          maxLength={maxLength}
          required
          className="w-full px-4 py-3 rounded-xl text-sm outline-none transition-shadow ring-1"
          style={{
            background:  'var(--surface)',
            color:       'var(--text-1)',
            paddingRight: isPassword ? '2.75rem' : undefined,
          }}
          onFocus={e => { e.currentTarget.style.boxShadow = '0 0 0 2px var(--brand)' }}
          onBlur={e  => { e.currentTarget.style.boxShadow = '0 0 0 1px var(--border)' }}
        />
        {isPassword && (
          <button
            type="button"
            tabIndex={-1}
            onClick={() => setShow(v => !v)}
            className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center transition-colors"
            style={{ color: show ? 'var(--brand)' : 'var(--text-3)' }}
            onMouseEnter={e => { e.currentTarget.style.color = 'var(--brand)' }}
            onMouseLeave={e => { e.currentTarget.style.color = show ? 'var(--brand)' : 'var(--text-3)' }}
          >
            <EyeIcon open={show} />
          </button>
        )}
      </div>
    </div>
  )
}
